import styled from 'styled-components';

interface StyledProps {
  $leftOpen?: boolean;
  $rightOpen?: boolean;
}

export const Layout = styled.div<StyledProps>`
  display: flex;
  width: 100%;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  margin-top: -1px;
`;

export const MainContent = styled.div<StyledProps>`
  flex: 1;
  margin-left: ${({ $leftOpen }) => ($leftOpen ? '232px' : '50px')};
  margin-right: ${({ $rightOpen }) => ($rightOpen ? '232px' : '50px')};
  transition: all 0.3s ease-in-out;
  width: calc(
    100% -
      ${({ $leftOpen, $rightOpen }) =>
        ($leftOpen ? '250px' : '50px') +
        ' - ' +
        ($rightOpen ? '250px' : '50px')}
  );

  @media (max-width: 768px) {
    margin-left: 50px;
    margin-right: 50px;
    padding: 0 10px;
    width: calc(100% - 100px);
  }
`;
